import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { FormikProps, Formik, Form, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputSelectField } from "../../../../components/Shared/InputSelectField";
import InputDateTime from "../../../../components/Shared/InputDateTime";

interface IFormProps {
    t?: any | undefined;
    moduleState: any;
    setQuery: any;
    dropdowns: any;
    visibility: any;
    toastify: any;
    onClose?: any;
}

type TInputForm = {
    roles: [],
    fromLocations: [],
    toLocations: [],
    toDate: null,
    fromDate: null,
};

const DEFAULT_FORM_STATE = {
    roles: [],
    fromLocations: [],
    toLocations: [],
    toDate: null,
    fromDate: null,
};

// @ts-ignore
function RoleFilter(props: IFormProps) {
    const { t, visibility, dropdowns } = props;
    const formRef: any = useRef();
    const [initFormState, setInitFormState] = useState<any>(DEFAULT_FORM_STATE);
    const [panelState, setPanelState] = useState<boolean>(false);
    // const [searchParams] = useSearchParams();

    const onSubmit = async (payloads: any) => {
        props.setQuery({
            ...props.moduleState,
            filters: payloads
        });
    };

    const onReset = () => {
        const base: any = formRef.current;
        if ( base ) {
            base.resetForm();
        }
    };

    const onClose = () => {
        setPanelState(false);
        onReset();
        if ( props.onClose ) {
            props.onClose();
        }
    };

    useEffect(() => {
        if ( visibility ) {
            setPanelState(visibility);
        }
    }, [visibility]);

    return (
        <>
            <div>
                <Sidebar
                    header={
                        <div className="bg-body-tertiary card-header">
                            <h5 className={ "card-title mt-0" }>{ t('advance filters') }</h5>
                            <p>{ t("using filters you can archive better result.") }</p>
                        </div>
                    }
                    visible={ panelState } position="left" onHide={ onClose } blockScroll={ true }
                    style={ { width: '800px' } } closeOnEscape={false}
                >
                    <div style={ {
                        height: '3px',
                        background: 'linear-gradient(90deg, var(--primary-color) 0%, rgba(33, 150, 243, 0) 50%)'
                    } }></div>
                    <Formik
                        innerRef={ formRef }
                        enableReinitialize={ true }
                        initialValues={ initFormState }
                        onSubmit={ onSubmit }
                    >
                        { (props: FormikProps<TInputForm>) => {
                            return (
                                <Form onSubmit={ props.handleSubmit }>
                                    <Row className={ "mt-4 md:mb-7 sm:mb-7" }>
                                        <Col sm={ 12 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns.roles }
                                                   name="roles"
                                                   optionLabel="name"
                                                   placeholder={ t("select") + ' ' + t("roles") }
                                                   label={ t('roles') }
                                                   autoFocus={ true }/>
                                        </Col>
                                        <Col sm={ 12 } md={ 6 }>
                                            <Field component={ InputDateTime }
                                                   name="fromDate"
                                                   type={ "datetime" }
                                                   label={ t("from date") }
                                                   isClearable={ true }
                                                   enableTimeStartOfDay
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 6 }>
                                            <Field component={ InputDateTime }
                                                   name="toDate"
                                                   type={ "datetime" }
                                                   label={ t("to date") }
                                                   isClearable={ true }
                                                   enableTimeEndOfDay
                                            />
                                        </Col>
                                    </Row>
                                    <div className="filter filter-card-footer"
                                         style={ { width: '785px' } }>
                                        <Button type={ "submit" } disabled={ props.isSubmitting }
                                                tooltip={ t("to data save into database") }
                                                size={ "small" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-filter me-2" />
                                            { t("filter") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onReset }
                                                tooltip={ t("to make all fields empty") } className={ "ms-2" }
                                                size={ "small" } severity={ "warning" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-refresh me-2" />
                                            { t("reset") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onClose }
                                                tooltip={ t("operation cancel") } className={ "ms-2" }
                                                size={ "small" } severity={ "danger" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-arrow-left me-2" />
                                            { t("close") }
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        }
                    </Formik>
                </Sidebar>
            </div>
        </>
    );
}

RoleFilter.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(RoleFilter);
